/***
 * File name: reportsMixin.js
 *
 * Program Description:
 * This file contains all the reusable functions used for generating and exporting
 * report to pdf and other possible format.
 *
 * Includes:
 * - Function that allows the user to view the generated report to a preview page
 * - This file uses the third party extension html2pdf to generate pdf files
 *
 */
/* eslint-disable import/no-absolute-path */
import * as html2pdf from 'html2pdf.js'

const reportsMixin = {
  methods: {
    viewPDF (element, dbn) {
      const opts = this.getOpts(dbn)

      html2pdf().from(element).set(opts).toPdf().get('pdf').then(function (pdf) {
        const totalPages = pdf.internal.getNumberOfPages()
        for (let i = 1; i <= totalPages; i++) {
          pdf.setPage(i)
          pdf.setFontSize(9)

          pdf.setFontSize(8).setFontType('bolditalic')
          pdf.text(dbn, 30, pdf.internal.pageSize.getHeight() - 20)

          pdf.text(`Page ${i} of ${totalPages}`, (pdf.internal.pageSize.getWidth()) - (90), pdf.internal.pageSize.getHeight() - 20)
        }

        // eslint-disable-next-line security/detect-non-literal-fs-filename
        window.open(pdf.output('bloburl'), '_blank')
      })
      dbn && this.$store.dispatch('showAlert', {
        message: 'Personal Data Breach Notification Form Generated.',
        type: 'success'
      })
    },
    getOpts (dbn) {
      return {
        margin: 30,
        filename: `PDBNF - ${dbn}.pdf`,
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2 },
        pagebreak: { mode: ['css', 'legacy', 'avoid-all'] },
        jsPDF: { unit: 'pt', format: 'a4', orientation: 'portrait' }
      }
    }
  }
}

export default reportsMixin
